import React from 'react';
import { Icon } from '../Icon';
import imageSrc from '../../assets/images/slide/pause-two-women-tablet.png';
import styles from './PauseSlideContentV20.css';

const STEPS = [
    { icon: 'messageSquareHeart', text: 'Easy questions, no right or wrong answers' },
    { icon: 'lock', text: 'Your answers stay private' },
    { icon: 'sparkleOutline', text: 'Your first question is ready at the end' }
];

function PauseSlideContentV20() {
    return (
        <section className={styles.form}>
            <img src={imageSrc} alt='' className={styles.image} />
            <h2 className={styles.heading}>Let’s start your story</h2>
            <p className={styles.description}>Answer a few questions. We’ll find the easiest way for you to record and pick your first questions.</p>
            <ul className={styles.steps}>
                {STEPS.map(step => (
                    <li key={step.icon} className={styles.step}>
                        <Icon name={step.icon} className={styles.stepIcon} />
                        {step.text}
                    </li>
                ))}
            </ul>
        </section>
    );
}

export {
    PauseSlideContentV20
};
